import { render } from "./NovoGrupo.vue?vue&type=template&id=2e345615"
import script from "./NovoGrupo.vue?vue&type=script&lang=js"
export * from "./NovoGrupo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__